module.exports = __webpack_public_path__ + "img/facebook.630fff0f.png";